var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 404,
    viewBox: "0 0 495 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.787 105.427L184.906 120.926L121.454 84.1148L149.306 68.6162L211.787 105.427Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.787 187.286L184.906 202.784L121.454 165.973L149.306 150.475L211.787 187.286Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.636 187.286L184.75 202.784L121.299 165.973L149.151 150.475L211.636 187.286Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.906 120.925V202.784",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.548 68.6162V150.476L121.479 165.946V84.0913",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.787 105.159V187.019",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.948 151.443L101.063 166.941L37.6113 130.13L65.4636 114.632L127.948 151.443Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.949 233.301L101.064 248.8L37.6123 211.989L65.4646 196.49L127.949 233.301Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.793 233.301L100.912 248.8L37.4609 211.989L65.3132 196.49L127.793 233.301Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.063 166.942V248.802",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7051 114.632V196.491L37.6406 211.961V130.107",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.949 151.174V233.033",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.188 146.36L356.307 161.858L292.855 125.047L320.708 109.544L383.188 146.36Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.188 228.214L356.307 243.718L292.855 206.902L320.708 191.403L383.188 228.214Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.037 228.214L356.156 243.718L292.7 206.902L320.552 191.403L383.037 228.214Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.308 161.859V243.719",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.949 109.544V191.403L292.885 206.878V125.019",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.189 146.09V227.944",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.49 192.544L439.609 208.043L376.157 171.232L404.005 155.729L466.49 192.544Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.49 274.398L439.609 289.901L376.157 253.086L404.005 237.587L466.49 274.398Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.339 274.398L439.453 289.901L376.002 253.086L403.854 237.587L466.339 274.398Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.609 208.044V289.903",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.251 155.729V237.588L376.182 253.063V171.204",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.49 192.274V274.129",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.646 90.9946L260.526 106.493L323.978 69.6822L296.13 54.1836L233.646 90.9946Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.646 172.853L260.526 188.352L323.978 151.541L296.13 136.042L233.646 172.853Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.797 172.853L260.683 188.352L324.134 151.541L296.282 136.042L233.797 172.853Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.526 106.493V188.353",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.885 54.1836V136.043L323.954 151.513V69.6539",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.646 90.7256V172.585",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.485 54.1128L201.366 69.6114L264.818 32.8004L236.97 17.3018L174.485 54.1128Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.485 135.972L201.366 151.471L264.818 114.66L236.97 99.1562L174.485 135.972Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.636 135.972L201.521 151.471L264.973 114.66L237.121 99.1562L174.636 135.972Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.366 69.6113V151.471",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.725 17.3018V99.1564L264.794 114.631V32.7721",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.485 53.8438V135.703",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.683 305.547L264.568 321.046L328.02 284.235L300.167 268.731L237.683 305.547Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.683 387.401L264.568 402.904L328.02 366.088L300.167 350.59L237.683 387.401Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.838 387.401L264.719 402.904L328.17 366.088L300.323 350.59L237.838 387.401Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.567 321.046V402.905",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.927 268.731V350.591L327.991 366.066V284.206",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.683 305.277V387.132",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.906 268.832L211.787 284.335L275.239 247.519L247.391 232.021L184.906 268.832Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.906 350.69L211.787 366.189L275.239 329.378L247.391 313.879L184.906 350.69Z",
    stroke: "#231F20",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.058 350.69L211.943 366.189L275.395 329.378L247.542 313.879L185.058 350.69Z",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.787 284.336V366.191",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.146 232.021V313.88L275.215 329.35V247.496",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.906 268.562V350.422",
    stroke: "white",
    strokeWidth: 1.13163,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6133 101.924L482.2 332.564",
    stroke: "white",
    strokeWidth: 9.06719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.871 305.343L341.442 354.598L139.79 237.61L228.298 188.352L426.871 305.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6602 287.36L147.173 238.101",
    stroke: "white",
    strokeWidth: 9.06719,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.648 220.872C205.394 220.514 204.451 220.25 203.418 219.957C205.356 216.803 207.232 213.738 209.189 210.555C208.19 210.306 207.364 210.098 206.403 209.853C208.213 206.486 209.986 203.19 211.834 199.744C210.708 199.579 209.774 199.442 208.515 199.258C212.528 193.595 214.852 187.263 217.271 180.591C219.789 187.187 221.986 193.581 226.112 199.253C224.848 199.432 223.891 199.569 222.736 199.734C224.584 203.148 226.352 206.42 228.201 209.839C227.291 210.07 226.47 210.277 225.386 210.551C227.333 213.715 229.229 216.798 231.181 219.967C230.115 220.264 229.172 220.523 227.941 220.867C230.407 224.38 232.779 227.756 235.372 231.458H219.845V243.675H214.791V231.547H199.16C201.777 227.818 204.149 224.437 206.648 220.872Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.027 251.68C310.178 251.44 309.542 251.26 308.844 251.062C310.155 248.926 311.423 246.861 312.743 244.706C312.069 244.537 311.508 244.395 310.857 244.235C312.079 241.957 313.281 239.727 314.53 237.398C313.767 237.285 313.139 237.195 312.286 237.068C314.997 233.239 316.572 228.958 318.204 224.45C319.906 228.911 321.391 233.23 324.182 237.068C323.329 237.19 322.678 237.28 321.9 237.393C323.15 239.704 324.343 241.915 325.592 244.225C324.974 244.381 324.423 244.522 323.692 244.706C325.007 246.847 326.29 248.931 327.61 251.072C326.889 251.27 326.252 251.449 325.422 251.68C327.092 254.056 328.69 256.339 330.449 258.838H319.953V267.098H316.534V258.899H305.968C307.736 256.376 309.339 254.089 311.032 251.68H311.027Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.832 311.185C351.983 310.944 351.347 310.765 350.649 310.567C351.96 308.431 353.228 306.366 354.548 304.211C353.874 304.042 353.313 303.9 352.662 303.74C353.883 301.462 355.086 299.232 356.335 296.903C355.571 296.79 354.944 296.7 354.091 296.573C356.802 292.744 358.377 288.463 360.008 283.955C361.71 288.416 363.196 292.735 365.987 296.573C365.134 296.695 364.483 296.785 363.705 296.898C364.954 299.209 366.147 301.42 367.397 303.73C366.779 303.886 366.227 304.027 365.497 304.211C366.812 306.352 368.095 308.436 369.415 310.577C368.693 310.775 368.057 310.954 367.227 311.185C368.896 313.561 370.495 315.843 372.253 318.342H361.758V326.603H358.339V318.404H347.772C349.541 315.881 351.144 313.594 352.837 311.185H352.832Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.467 228.393C187.038 227.988 185.968 227.686 184.794 227.351C187.001 223.758 189.137 220.274 191.362 216.648C190.226 216.36 189.287 216.125 188.189 215.851C190.249 212.018 192.267 208.264 194.375 204.341C193.093 204.153 192.032 203.997 190.594 203.785C195.158 197.335 197.812 190.125 200.561 182.529C203.428 190.04 205.932 197.321 210.628 203.78C209.19 203.983 208.096 204.139 206.785 204.327C208.888 208.217 210.902 211.942 213.005 215.832C211.967 216.096 211.034 216.332 209.798 216.643C212.014 220.246 214.174 223.754 216.395 227.365C215.183 227.7 214.108 228.002 212.707 228.389C215.513 232.392 218.215 236.235 221.171 240.445H203.489V254.355H197.732V240.544H179.933C182.913 236.296 185.614 232.444 188.462 228.389L188.467 228.393Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.499 232.764C284.071 232.359 283 232.057 281.826 231.722C284.033 228.129 286.169 224.645 288.394 221.019C287.258 220.731 286.32 220.496 285.221 220.222C287.282 216.389 289.3 212.636 291.407 208.713C290.125 208.524 289.064 208.368 287.626 208.156C292.19 201.706 294.845 194.496 297.594 186.9C300.46 194.412 302.964 201.692 307.66 208.151C306.222 208.354 305.128 208.51 303.817 208.698C305.92 212.588 307.934 216.313 310.037 220.203C308.999 220.467 308.066 220.703 306.83 221.014C309.047 224.617 311.206 228.125 313.427 231.737C312.215 232.071 311.14 232.373 309.74 232.76C312.545 236.763 315.247 240.606 318.203 244.816H300.522V258.726H294.764V244.915H276.965C279.945 240.667 282.647 236.815 285.495 232.76L285.499 232.764Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.429 323.827C329 323.421 327.93 323.12 326.756 322.785C328.963 319.192 331.098 315.707 333.324 312.082C332.188 311.794 331.249 311.558 330.151 311.285C332.211 307.451 334.229 303.698 336.337 299.775C335.054 299.586 333.994 299.431 332.555 299.219C337.12 292.768 339.774 285.559 342.523 277.963C345.39 285.474 347.894 292.754 352.59 299.214C351.152 299.417 350.058 299.572 348.747 299.761C350.85 303.651 352.863 307.376 354.966 311.266C353.929 311.53 352.996 311.766 351.76 312.077C353.976 315.679 356.136 319.187 358.357 322.799C357.145 323.134 356.07 323.436 354.669 323.822C357.475 327.825 360.177 331.668 363.133 335.879H345.451V349.788H339.694V335.978H321.895C324.874 331.729 327.576 327.877 330.424 323.822L330.429 323.827Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 2.26798,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.345 72.6776L150.217 7.23633L7 96.1212L163.651 187.533",
    stroke: "#F69320",
    strokeWidth: 6.79921,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.874 129.282L487.293 211.245L342.425 283.406L334.546 287.616L254.695 241.017",
    stroke: "#F69320",
    strokeWidth: 6.79921,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205.021 77.8436C226.315 77.8436 243.577 60.5817 243.577 39.288C243.577 17.9944 226.315 0.732422 205.021 0.732422C183.728 0.732422 166.466 17.9944 166.466 39.288C166.466 60.5817 183.728 77.8436 205.021 77.8436Z",
    fill: "#F69320"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M352.016 152.735L351.657 128.631L376.181 126.792",
    stroke: "#F69320",
    strokeWidth: 6.79921,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.042 166.752L167.969 189.842L144.879 198.306",
    stroke: "#F69320",
    strokeWidth: 6.79921,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.9f3c290fd24400726de0a368112c1260.svg";
export { ForwardRef as ReactComponent };